module.exports = __webpack_public_path__ + "img/portfolio.0816bfde.jpg";